import SaverApi from '../../api/SaverApi';

const SignupErrorTypes = {
  OK: 'OK',
  SAVER_ALREADY_EXISTS: 'SAVER_ALREADY_EXISTS',
};

const state = {
  firstName: undefined,
  lastName: undefined,
  email: undefined,
  enableMarketingEmails: true,
};

const getters = {
  SignupErrorTypes: () => SignupErrorTypes,
};

const actions = {
  async signup({ state }) {
    const { status } = await SaverApi.signup({
      firstName: state.firstName,
      lastName: state.lastName,
      email: state.email,
      enableMarketingEmails: state.enableMarketingEmails,
    });
    return status;
  },
  async signupMember({ state }) {
    const { status } = await SaverApi.signupMember();
    return status;
  },
};

const mutations = {
  setFirstName(state, firstName) {
    state.firstName = firstName;
  },
  setLastName(state, lastName) {
    state.lastName = lastName;
  },
  setEmail(state, email) {
    state.email = email;
  },
  setEnableMarketingEmails(state, enableMarketingEmails) {
    state.enableMarketingEmails = enableMarketingEmails;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
